<template>
  <div>
        <el-tabs type="border-card">

            <el-tab-pane label="上传图片">
                <div>
                    <el-button size='mini' type="info" v-if="isUploadFlag" plain @click="onUploadRes">上传</el-button>

                    <el-button size='mini' type="info" plain @click="onRefer">刷新</el-button>
                    <el-form :inline="true" :model="dataForm" class="demo-form-inline" size="mini" ref="dataForm">
                      <el-form-item prop="auditStatus" >
                        <el-select v-model="dataForm.auditStatus" placeholder="审核状态" style="width: 120px" @change="handleChange">
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item prop="user" >
                            <el-input v-model="dataForm.user" placeholder="请输入名称关键词"></el-input>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" @click="onSearchUpload(0)">查询</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="resetForm('dataForm')" type="primary" plain>重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div>
                    <el-table ref="multipleTable" id="myTable" :data="tableDatas" tooltip-effect="dark" border @selection-change="handleSelectionChange">
                        <el-table-column align="center" type="selection"></el-table-column>
                        <el-table-column align="center" type=index label="序号"></el-table-column>
                        <el-table-column align="center" prop="VAttachmentName" show-overflow-tooltip label="附件名称"></el-table-column>
                        <el-table-column align="center" prop="VAttachmentNumber"   label="图片编号"></el-table-column>
                        <el-table-column align="center" prop="keyrord"  label="关键词"></el-table-column>
                        <el-table-column align="center" prop="categoryname"  label="所属类别"></el-table-column>


                        <el-table-column align="center" prop="Filmlocations"  label="拍摄日期"></el-table-column>
                        <el-table-column align="center" prop="place" show-overflow-tooltip label="拍摄地点"></el-table-column>

                        <el-table-column prop="VAttachmentRemotePath" label="图片" width="width" align="center">
                          <template slot-scope="{ row, $index }">
                            <!-- 图片显示 -->
                            <el-image
                              :src="baseUrl + row.VAttachmentRemotePath"
                              :preview-src-list="[baseUrl + row.VAttachmentRemotePath]"
                              preview-infinite="true"
                              @click="openImage(row, $index)"
                              style="height: 90px; cursor: pointer"
                              ref="imagePreview"
                            ></el-image>
                          </template>
                        </el-table-column>
                      <el-table-column align="center" prop="imgSource" :formatter="imageSource" label="來源"></el-table-column>

                      <el-table-column align="center" property="auditStatus" label="审核状态"  width="80" fixed="right" >
                        <template slot-scope="scope" >
                          <span :class="formatStatusColor(scope.row.auditStatus)" :title="auditStatusClik(scope.row)" > {{ formatStatus(scope.row.auditStatus) }}
                            <i :class="formatIcon(scope.row.auditStatus)"></i>
                          </span>
                        </template>
                      </el-table-column>
                      <el-table-column align="center"  property="auditStatus" label="操作" width="130"  fixed="right">
                        <template slot-scope="scope" >
                          <el-button size="mini" type="primary" plain v-if="isUploadFlag && (scope.row.auditStatus==2||scope.row.auditStatus==0)" @click="editPic(scope.row)">编辑</el-button>
                          <el-button size="mini" type="danger" plain v-if="isUploadFlag && (scope.row.auditStatus==2||scope.row.auditStatus==0)" @click="deletePic(scope.row,scope.$index)">删除</el-button>
                        </template>
                      </el-table-column>

                      <el-table-column align="center" prop="DAttachmentSize" label="图片大小" :formatter="getFileSize"></el-table-column>
                      <el-table-column align="center" prop="imagewidth" :formatter="fenbianlvFormatter" label="分辨率"></el-table-column>
                      <el-table-column align="center" prop="createdTime"   label="上传时间"></el-table-column>

                    </el-table>
                    <el-pagination
                        background
                        @current-change="handleCurrentChange"
                        :page-sizes="[10]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total='totalCount'
                        class="sorter">
                    </el-pagination>
                </div>
            </el-tab-pane>

        </el-tabs>


  </div>
</template>

<script>
import { getUser} from "./../../../../untils/auth.js"
import {none} from "html-webpack-plugin/lib/chunksorter";
export default {
    name:'mypicfile',
    data() {
        return {
          isUploadFlag:true,
          imgSrc: require('../../../../assets/images/home.png'),
          imgSrc1: "",
          VAttachmentId: "",
          rotateDeg: 0, // 图片旋转角度
          totalCount:0,
          previewList: [], // 预览图片列表
          currentIndex: -1, // 当前选中图片的索引
          dataForm:{
              user:'',
              auditStatus:'',
          },
          // 下拉选项的数据
          options: [
            { value: '0', label: '待审核' },
            { value: '1', label: '审核通过' },
            { value: '2', label: '审核未通过' }
          ],
            tableDatas: [],
            baseUrl:''
        }
    },



  created() {
    var VUserId = JSON.parse(getUser()).principal.VUserId
    this.axios.post(window.IPConfig.IP + '/tBusCamerist/getByVUserId.do?VUserId='+VUserId).then((response) => {
      if (response.status == 200) {
        if (response.data.status == 200) {
          var obj = response.data.obj;
          if (obj.vcameristStatus==1){
            this.isUploadFlag =false;
          }
        }
      }
    })
        this.eduDataRes('','1')
    },

    methods: {
      handleChange(value) {
        this.dataForm.auditStatus=value;
      },

      resetForm(e) {
        this.dataForm.user="";
        this.dataForm.auditStatus="";
        this.onSearchUpload(0)
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      handleCurrentChange(val) {
        this.eduDataRes('', val);
      },
      // 上传资料跳转
      onUploadRes() {
        this.$router.push({
          path: 'picUpload',
        })
      },
      // 查询已上传的资料
      onSearchUpload(current) {
        this.axios.post(window.IPConfig.IP + '/tBAttachments/queryPage.do',
          {
            VAttachmentName: this.dataForm.user,
            current: current,
            size: '10',
            imgCopyright: JSON.parse(getUser()).principal.VUserId,
            VAttachmentType: 1,
            auditStatus:this.dataForm.auditStatus
          }
        ).then((response) => {
          if (response.status == 200) {
            this.baseUrl = response.data.url;
            if (response.data.obj) {
              this.tableDatas = response.data.obj.records;
              this.totalCount = response.data.obj.total;
            } else {
              this.$message({
                message: '无数据',
                type: 'error'
              })
            }
          }
        })
      },
      // 已上传资料
      eduDataRes(type, current) {
        this.axios.post(window.IPConfig.IP + '/tBAttachments/queryPage.do',
          {
            imgCopyright: JSON.parse(getUser()).principal.VUserId,
            current: current,
            size: '10',
            VAttachmentType: 1
          }
        ).then((response) => {
          if (response.status == 200) {
            if (response.data.status == 200) {
              this.baseUrl = response.data.url;
              if (response.data.obj) {
                this.tableDatas = response.data.obj.records;
                this.totalCount = response.data.obj.total;
              } else {
                this.$message({
                  message: '无数据',
                  type: 'error'
                })
              }
            }
          }
        })
      },


      // 格式化状态显示
      formatStatus(status) {
        if (status == 0) {
          return '待审核'
        } else if (status == 1) {
          return '审核通过'
        } else if (status == 2) {
          return '审核驳回'
        } else {
          return ''
        }
      },
      // 格式化状态显示的颜色
      formatStatusColor(status) {
        if (status == 1) {
          return 'color2'
        } else if (status == 0) {
          return 'color1'
        } else if (status == 2) {
          return 'color3'
        } else {
          return ''
        }
      },
      auditStatusClik(row) {
        if (row.auditStatus == 2) {
          var date2 = new Date();
          var date1 = new Date(Date.parse(row.createdTime.replace(/-/g, "/")));
          var iDays = parseInt(Math.abs(date2.getTime() - date1.getTime()) / 1000 / 60 / 60 / 24);
          return (row.auditRemark == undefined ? '' : "驳回原因:" + row.auditRemark + ";") + "剩余" + (30 - iDays) + "天自动删除";
        } else {
          return ''
        }
      },

      formatIcon(status) {
        if (status == 0) {
          return 'el-icon-loading'
        } else if (status == 1) {
          return 'el-icon-circle-check'
        } else if (status == 2) {
          return 'el-icon-warning'
        } else {
          return ''
        }
      },


      fenbianlvFormatter(row, column) {
        return row.imagewidth + "*" + row.imageheight;
      },
      imageSource(row, column) {
        if (row.imgSource == 0) {
          return '系统后台'
        } else if (row.imgSource == 1) {
          return '摄影师上传'
        } else {
          return ''
        }
      },

      getFileSize(row, column) {
        var data = (row.DAttachmentSize / (1024 * 1024)).toFixed(2) + "MB";
        var sizestr = data + "";
        var len = sizestr.indexOf("\.");
        var dec = sizestr.substr(len + 1, 2);
        if (dec == "00") {//当小数点后为00时 去掉小数部分
          return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
        }
        return sizestr;
      },


      // 刷新
      onRefer() {
        this.eduDataRes('', '1')
      },



      openImage(row,index) {

        this.rotateDeg = 0; // 每次打开时重置旋转角度
        this.imgSrc1 = this.baseUrl + row.VAttachmentRemotePath;
        this.VAttachmentId = row.VAttachmentId;

        this.currentIndex=index;

        const previewWrapper = document.getElementsByClassName('el-image-viewer__wrapper');
        if (previewWrapper[this.currentIndex].style.display === 'none') {
          previewWrapper[this.currentIndex].style.display = ''; // 可以使用 'block' 如果是需要块级元素
        } else {
          previewWrapper[this.currentIndex].style.display = 'none';
        }
        this.$nextTick(() => {
          var wrapper = document.getElementsByClassName("el-image-viewer__actions__inner");
          let downImg = document.createElement("i");
          downImg.setAttribute("class", "el-icon-check");
          downImg.title = " 保存"; // 添加文字内容
          downImg.style.cursor = "pointer";
          downImg.style.fontSize = "xxx-large";

          if (wrapper[index].children[wrapper[index].children.length-1].className !=("el-icon-check")) {
            wrapper[index].appendChild(downImg);
            if (wrapper.length > 0) {
              this.wrapperElem = wrapper[index];
              this.cusClickHandler();
            }
          }
        });
      },


      // 给按钮添加点击事件
      cusClickHandler() {
        this.wrapperElem.addEventListener("click", this.hideCusBtn);
      },
      // 点击事件
      hideCusBtn(e) {
          let className = e.target.className;
        // 旋转照片
          if (className === "el-icon-refresh-right" || "el-icon-refresh-left") {
            var element = document.getElementsByClassName("el-image-viewer__img");

            var degA = element[this.currentIndex].style.transform.substring(16);
            var deg = degA.substring(0, degA.length - 4) % 360;
            this.rotateDeg=deg
          }

          if (className === "el-icon-check") {
            if (this.rotateDeg !=0 && this.rotateDeg !=-0){
              // 请求后台旋转图片
              try {
                // 发送 POST 请求，忽略返回值
                this.axios.post(window.IPConfig.IP + "/tBAttachments/rotateImg.do?id="+this.VAttachmentId+"&degrees="+ this.rotateDeg);
                this.$message({
                  type: "success",
                  message:"已发送请求，需要大概两分钟处理，请稍后刷新查看!",
                });

                const previewWrapper = document.getElementsByClassName('el-image-viewer__wrapper');
                previewWrapper[this.currentIndex].style.display = 'none';
              } catch (error) {
                // 处理错误（如果需要）
                console.error('请求失败:', error);
              }
            }else{
              this.$message({
                type: "warning",
                message:"图片未发生变化!",
              });
            }
          }


      },


      editPic(row) {
        this.$router.push({
          path: 'updatePic',
          query: {
            VAttachmentId: row.VAttachmentId,
          }
        })
      },




      deletePic(row,index) {
        this.$confirm('确定要删除这一行吗？', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var ids = [];
          ids.push(row.VAttachmentId);
          var id = ids.join(',');
          this.axios.post(window.IPConfig.IP + '/tBAttachments/deleteById.do?ids='+id).then((response) => {
            if (response.status == 200) {
              if (response.data.status == 200) {
                this.tableDatas.splice(index, 1);
                this.$message({
                  type: 'success',
                  message: '删除成功'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: '删除失败'
                })
              }
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })

      }

    }
}
</script>

<style lang="stylus" scoped>

.demo-form-inline {
    float:right
}
.sorter {
  text-align: center;
  margin-top: .1rem;
}
.el-table .cell, .el-table td {
  padding: none !important;
}

.el-button+.el-button {
  margin-left: 0 !important;
}
// 状态的三种颜色样式
.color1{
  color: #5fb878
}
.color2{
  color: #ffb800
}
.color3{
  color: red;
  cursor :pointer
}

.el-image-viewer__wrapper {
  display: none;
  transition: opacity 0.3s;
}

.fade-in {
  opacity: 1;
}

.fade-out {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Personalcenter/components/my/mypicfile.vue